export const appHead = {"meta":[{"name":"viewport","content":"width=device-width,initial-scale=1.0"},{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"zp-powered-by","content":"ZedPlan.com"},{"name":"zp-generator","content":"Gonzalo"},{"property":"og:title","content":"DivasPlay"},{"property":"og:description","content":"DivasPlay"},{"property":"og:site_name","content":"DivasPlay"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://divasplay.com"},{"property":"og:image","content":"https://divasplay.com/img/logo.png"}],"link":[{"href":"https://fonts.googleapis.com/css?family=Raleway","rel":"stylesheet"},{"rel":"icon","type":"image/x-icon","href":"/favicon.jpeg"}],"style":[],"script":[{"src":"/v2/js/load-cookies.js","async":true},{"src":"/v2/js/element-closest.js"},{"src":"/v2/js/gtag.js"}],"noscript":[{"innerHTML":"<strong>Divasplay no esta disponible sin JavaScript</strong>"}],"htmlAttrs":{"lang":"es"},"title":"DivasPlay","charset":"utf-8","viewport":"width=device-width,initial-scale=1.0"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"